export const fontConfig = {
  families: ['Zen+Maru+Gothic:400,500,700', 'Ubuntu:300,400,500,600,700'],
  display: 'swap',
  api: 'https://fonts.googleapis.com',
  cssApi: 'https://fonts.gstatic.com',
};
